module.exports = __webpack_public_path__ + "resource/img/image041Dark.4641c0b0.png";